export default __webpack_public_path__ + "static/media/google-upload-1-tw.a26e1be4.jpeg";